export class CreateRenameFolderConfig {
  public ParentID?: number = null;
  public ParentFolderID?: number = null;
  public loggedInUserID?: number = null;
  public currentName: string = '';
  public dialogTitle: string = '';
  public buttonText: string = '';
  public isEdit: boolean = false;
  public clear(): void {
    this.currentName = '';
    this.dialogTitle = '';
    this.buttonText = '';
    this.isEdit = false;
  }
}